import React from 'react';
import { IIconProps } from './utils';

export const Hide = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="2 2.5 12 12"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 8.5C7 7.5 6.53001 7.03001 5.33333 5.83333M8 8.5L2 2.5M8 8.5L14 14.5"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="1.33333"
    />
    <path
      d="M6.48926 6.04785C5.39331 6.36466 4.35501 7.03186 3.50195 8.04883C3.27808 8.3158 3.27824 8.68217 3.50195 8.94922C4.96923 10.699 6.96381 11.3947 8.83887 11.1006C9.20222 11.0439 9.54328 11.293 9.60059 11.6562C9.65739 12.0196 9.40907 12.3605 9.0459 12.418C6.68557 12.7883 4.23163 11.8961 2.47949 9.80664C1.84028 9.04411 1.84028 7.95491 2.47949 7.19238C3.33553 6.17171 4.35401 5.44128 5.44238 5.00098L6.48926 6.04785ZM6.91504 4.58789C9.26579 4.20504 11.7432 5.07301 13.5205 7.19238C14.1598 7.95481 14.1595 9.04405 13.5205 9.80664C13.3064 10.062 13.0799 10.2986 12.8457 10.5186L11.9033 9.57617C12.1093 9.38494 12.3089 9.17596 12.499 8.94922C12.7223 8.68223 12.7227 8.31561 12.499 8.04883C11.3016 6.621 9.73879 5.88467 8.16406 5.83691L6.91504 4.58789ZM9.80273 9.36133C9.4807 10.0343 8.79575 10.5 8 10.5C6.89557 10.5 6.00022 9.60438 6 8.5C6.00002 8.38719 6.00937 8.27569 6.02734 8.16797C6.04285 8.07758 6.169 8.06397 6.22754 8.13477C6.41095 8.35755 6.6889 8.5 7 8.5C7.53354 8.49995 7.96816 8.08202 7.99707 7.55566L9.80273 9.36133Z"
      fill={fill}
    />
  </svg>
);
